<template lang="pug">
div
  BookView(:book="book")
  //- FeedbackForm(:entityId="book.id" entityType="Content" :message="$t('feedback')")
</template>

<script>
import { Book } from '~/graphql/Book.gql';
import BookView from '~/components/BookViewer';
import FeedbackForm from '~/components/forms/FeedbackForm';
import { generateContentSeo } from '~/utils/seo';

export default {
  i18nLocaleRoot: '/books',
  meta: {
    logoText: 'books',
    theme: 'books'
  },
  components: {
    BookView,
    FeedbackForm
  },
  head() {
    return generateContentSeo(this.book);
  },
  async asyncData({ app, params, error }) {
    try {
      const { data } = await app.$api.query({
        query: Book,
        variables: {
          slug: params.slug
        }
      });
      console.log(data);
      if (!data.book) {
        error({ statusCode: 404, message: 'BOOK_NOT_FOUND' });
        return;
      }

      app.applyContentTheme(data.book);
      app.verifyContentLocale(data.book);

      return {
        book: data.book
      };
    } catch (err) {
      error({ statusCode: 404 });
    }
  }
};
</script>
<i18n>
{
  "en": {
    "feedback":"Have feedback on the book?"
  },
  "ar": {
    "feedback":"هل لديك ملاحظات حول الكتاب؟"
  }
}
</i18n>
